export default function terminology(
  value: string,
  { isPlural = undefined }: { isPlural?: boolean } = {}
) {
  const globalTerminology = window.terminology;
  if (!globalTerminology) {
    return value;
  }
  return globalTerminology(value, { isPlural });
}
